import React, {useState, useRef} from 'react';
import { useHistory,  useLocation} from 'react-router-dom';
import '../../../css/loginsheet.scss';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css'
import { useEffect } from "react";
import APICall from '../../actions/apicall';
import Cookies from "js-cookie";
import eyeicon from '../../../images/eyeicon.png';
import appleIcon from '../../../images/appleIcon.png'
import facebookIcon from '../../../images/facebookIcon.png'
import googleIcon from '../../../images/googleIcon.png'
import inbox from '../../../images/inbox.png'
import cancelIcon from '../../../images/cancelIcon.png'
import { GoogleOAuthProvider, GoogleLogin, useGoogleLogin } from '@react-oauth/google';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'; 
import AppleLogin from 'react-apple-login';
import Submit from '../reusable/Submit';
import ForgotPassword from '../popups/ForgotPassword';

function LoginBottomSheet(props) {
    const history = useHistory();
    const location = useLocation();
    const passwordElement = useRef();
    const signUpPasswordElement = useRef();
    const accountSheetElement = useRef();

    const [showLogin, setShowLogin] = useState(false);
    const [emailAddress, setEmailAddress] = useState('');
    const [loginPassword, setLoginPassword] = useState('');
    const [signUpEmail, setSignUpEmail] = useState('');
    const [signUpPassword, setSignUpPassword] = useState('');
    const [showAccount, setShowAccount] = useState(true);
    const [showLoginError, setShowLoginError] = useState(false);
    const [showAccountError, setShowAccountError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [accountErrorMessage, setAccountErrorMessage] = useState('');
    const [resendText, setResendText] = useState(false);
    const [openForgotPassword, setOpenForgotPassword] = useState(false);
    const [signInText, setSignInText] = useState('Sign In');
    const [createAccountText, setCreateAccountText] = useState('Create Account');
    const [firstClick, setFirstClick] = useState(false);
    const [resendTextMessage, setResendTextMessage] = useState('Sending email...');
    const [showLoginLink, setShowLoginLink] = useState(false);
    const [showAccountLoader, setShowAccountLoader] = useState(false);
    const [showLoginEmail, setShowLoginEmail] = useState(true);
    const [nextText, setNextText] = useState('Next');
    const [setPassword, setSetPassword] = useState(false);
    const [userId, setUserId] = useState(null);

    const reloadMarkers = true;
    const closeSheet = false;

    const handleLogin = () => {
        setSignInText('Signing In...');
        (showLoginError) && setShowLoginError(false);

        const handleLoginResponse = (response) => {
            if (response.status == 200 && response.data.status == 'success'){
                const access_token = response.data.data.access_token;
                Cookies.set('access_token', access_token);
                Cookies.set('username', response.data.data.username);
               
                // Cookie for GTM
                Cookies.set('rs11_user_id', response.data.data.user_id);

                let business_check = props.business
                let business_id = ''
                if(business_check){business_id = business_check.id}

                // Google Event For Login
                window.dataLayer.push({'event': 'login', 'method': 'email', 'businessId': business_id});
                
                var time = new Date();
                const utc_time = time.setSeconds(time.getSeconds() + response.data.data.expires_in);
                const token_expires_in = time.toISOString();
                Cookies.set('token_expires_in', token_expires_in);
                handleCloseButtonClick(reloadMarkers);
                if (location.pathname != '/map') {
                    history.push('/map');
                }
            }
            else {
                setSignInText('Sign In');
                setErrorMessage(response.data.message);
                setShowLoginError(true);
            }
        }

        if (setPassword) {
            let data = {
                user_id: userId,
                password: loginPassword,
                set_password: true
            }
            
            window.dataLayer.push({'event': 'set_new_password'});
    
            APICall.SetNewPassword(data, (response) => {
                handleLoginResponse(response);
            });
        }
        else {
            let data = {
                username: emailAddress,
                password: loginPassword,
            }
            APICall.Login(data, (response) => {
                handleLoginResponse(response);
            });
        }
    }

    const handleCheckPassword = () => {
        setNextText('Submitting...');
        setShowLoginError(false);
        let data = {
            email: emailAddress
        }
        APICall.CheckSetPassword(data, (response) => {
            if (response.status == 200 && response.data.status == 'success') {
                (!response.data.data.set_password) && setSetPassword(true);
                setShowLoginEmail(false);
                setUserId(response.data.data.user_id);
            }
            else {
                setErrorMessage(response.data.message);
                setShowLoginError(true);
            }
            setNextText('Next');
        })
    }

    useEffect(() => {
        if (props.showLoginContent) {
            setShowAccount(true);
            setShowLogin(true);
        }
        (props.showInbox) && setShowAccount(false);
       
    }, [props.business, props.showLoginContent, props.showInbox]);
    

    const handleCloseButtonClick = (action) => {

        if (showAccount) {
            var currentSheet = 'account'
        }
        else {
            var currentSheet = 'resend'
        }
        Cookies.remove('signup_id');  
        props.onBottomSheetClose(action, currentSheet);
        // setShowLogin(false);
        setEmailAddress('');
        setLoginPassword('');
        setSignUpEmail('');
        setSignUpPassword('');
        setShowAccount(true);
        setShowLoginError(false);
        setShowAccountError(false);
        setErrorMessage('');
        setAccountErrorMessage('');
        setResendText(false);
        setOpenForgotPassword(false);
        setSignInText('Sign In');
        setFirstClick(false);
        setResendTextMessage('Sending email…');
        setShowLoginLink(false);
        setShowLoginEmail(true);
        // (!showAccount) && setShowAccount(true);
        setCreateAccountText('Create Account');
    };

    const handlePassword = () => {
        if(passwordElement.current.type === 'password') {
            passwordElement.current.type = 'text';
        }
        else {
            passwordElement.current.type = 'password';
        }
    };

    const socialLogin = (loginType, accessToken) => {
        setShowAccountLoader(true);
        if (accountSheetElement.current) {
            accountSheetElement.current.style.pointerEvents = 'none';
            accountSheetElement.current.style.opacity = '0.3';
        }
        let data = {
          'token': accessToken,
          'backend': loginType
        }
        APICall.SocialLogin(data, (response) => {
            if (response.data.status == 'success') {
                const access_token = response.data.data.access_token;
                Cookies.set('access_token', access_token);
                Cookies.set('username', response.data.data.username);
                //Cookie for GTM
                Cookies.set('rs11_user_id', response.data.data.user_id);

                let business_check = props.business
                let business_id = ''
                if (business_check) { business_id = business_check.id }

                // Google Event For Social Login
                if (loginType == 'google-oauth2') {loginType = 'google'}
                if (response.data.data.new_account) {
                    window.dataLayer.push({ 'event': 'sign_up', 'method': loginType, 'business_id': business_id });
                }
                else {
                    window.dataLayer.push({ 'event': 'login', 'method': loginType, 'business_id': business_id});
                }

                var time = new Date();
                const utc_time = time.setSeconds(time.getSeconds() + response.data.data.expires_in);
                const token_expires_in = time.toISOString();
                Cookies.set('token_expires_in', token_expires_in);
                handleCloseButtonClick(reloadMarkers);
                if (accountSheetElement.current) {
                    accountSheetElement.current.style.pointerEvents = 'all';
                    accountSheetElement.current.style.opacity = '1';
                }
                setShowAccountLoader(false);
                if (location.pathname != '/map') {
                    history.push('/map');
                }
                //   else if (props.showLoginContent){
                //       window.location.reload();
                //   }
            }
            else {
                if (accountSheetElement.current) {
                    accountSheetElement.current.style.pointerEvents = 'all';
                    accountSheetElement.current.style.opacity = '1';
                }
                setShowAccountLoader(false);
                setErrorMessage(response.data.message);
                setShowLoginError(true);
            }
        });
    }

    const appleSignin = (data) => {
        setShowAccountLoader(true);
        if (accountSheetElement.current) {
            accountSheetElement.current.style.pointerEvents = 'none';
            accountSheetElement.current.style.opacity = '0.3';
        }
        APICall.AppleSignin(data, (response) => {
          if (response.data.status == 'success'){
              //Cookie for GTM
              Cookies.set('rs11_user_id', response.data.data.user_id);

              let business_check = props.business
              let business_id = ''
              if(business_check){business_id = business_check.id}
              
              // Google Event For Apple sign-in
              if(response.data.data.new_account){
                window.dataLayer.push({'event': 'sign_up', 'method': 'apple', 'business_id': business_id});
              }
              else{
                window.dataLayer.push({'event': 'login', 'method': 'apple', 'business_id': business_id});
              }
            
              const access_token = response.data.data.access_token;
              Cookies.set('access_token', access_token);
              Cookies.set('username', response.data.data.username);
              var time = new Date();
              const utc_time = time.setSeconds(time.getSeconds() + response.data.data.expires_in);
              const token_expires_in = time.toISOString();
              Cookies.set('token_expires_in', token_expires_in);
              handleCloseButtonClick(reloadMarkers);
              if (accountSheetElement.current) {
                accountSheetElement.current.style.pointerEvents = 'all';
                accountSheetElement.current.style.opacity = '1';
              }
              setShowAccountLoader(false);
              if (location.pathname != '/map') {
                  history.push('/map');
              }
            //   else if (props.showLoginContent){
            //       window.location.reload();
            //   }
          }
          else {
            if (accountSheetElement.current) {
                accountSheetElement.current.style.pointerEvents = 'all';
                accountSheetElement.current.style.opacity = '1';
            }
            setShowAccountLoader(false);
            setErrorMessage(response.data.message);
            setShowLoginError(true);
          }

        });
    }

    const handleEnterEmail = () => {
        setCreateAccountText('Creating Account...');
        (showLoginLink) && setShowLoginLink(false);
        (showAccountError) && setShowAccountError(false);
        let storedSuggester = window.localStorage.getItem('suggester');
        let storedSearchValue = window.localStorage.getItem('searchValue');
        let storedInterest = window.localStorage.getItem('business_interests');
        
        let business_check = props.business
        let business_id = ''
        if(business_check){business_id = business_check.id}
        window.dataLayer.push({'event': 'sign_up', 'businessId': business_id, 'method': 'email'});
        
        var data = {
            email: signUpEmail,
            interests: storedInterest,
            suggester: storedSuggester,
            suggested_value: storedSearchValue,
        }

        APICall.CreateAccount(data, (response) => {
            if (response.status == 200 && response.data.status == 'success'){
                setShowAccount(false);
                setCreateAccountText('Create Account');
                // Cookies.set('signup_id', signUpEmail);
            }
            else {
                setCreateAccountText('Create Account');
                if (response.data.message == 'Email already exists. Please signin!') {
                    setShowLoginLink(true);
                }
                else {
                    setAccountErrorMessage(response.data.message);
                    setShowAccountError(true);
                }
            }
        });
    }

    const handleCreateAccountOrResend = (userAction) => {
        (showAccountError) && setShowAccountError(false);
        (showLoginLink) && setShowLoginLink(false);
        if (userAction == 'resend') setResendText(true)
        let suggester = null;
        let storedSuggester = window.localStorage.getItem('suggester');
        (storedSuggester == 'zipcode') && (suggester = 'zip_code');
        (storedSuggester == 'city') && (suggester = 'location_address_city');
        let suggestedValue = window.localStorage.getItem('searchValue');
        var data = {
            email: signUpEmail != '' ? signUpEmail : Cookies.get('signup_id'),
            suggester: suggester,
            business_id: props.selectedBusinessId,
            suggested_value: suggestedValue,
            business_type: (props.business && (props.business.fields.category)),
        }
        if (userAction == 'resend') {
            window.dataLayer.push({'event': 'resend_email'})
            APICall.ResendMail(data, (response) => {
                if (response.status == 200 && response.data.status == 'success'){
                    setResendTextMessage(response.data.message);
                }
                else {
                    setResendTextMessage(response.data.message);
                }
            });
        }
        else {
            setCreateAccountText('Creating Account...');
            if (firstClick) {
                let passwordData = {
                    username: signUpEmail,
                    password: signUpPassword,
                    first_clicked: true
                }
                APICall.SetPassword(passwordData, (response) => {
                    if (response.status == 200 && response.data.status == 'success'){
                        let businessId = props.selectedBusinessId ?? null
                        
                        // Cookie for GTM
                        Cookies.set('rs11_user_id', response.data.data.user_id);
                        // Google Event For signup completed
                        window.dataLayer.push({'event': 'sign_up', 'method': 'email', 'businessId': businessId});
                        
                        const access_token = response.data.data.access_token;
                        window.sessionStorage.removeItem('signup_email');  
                        Cookies.set('access_token', access_token);
                        Cookies.set('username', response.data.data.username);
                        var time = new Date();
                        const utc_time = time.setSeconds(time.getSeconds() + response.data.data.expires_in);
                        const token_expires_in = time.toISOString();
                        Cookies.set('token_expires_in', token_expires_in);
                        props.onBottomSheetClose(true);
                        if (location.pathname != '/map') {
                            history.push('/map');
                        }
                    }
                    else {
                        if (response.data.message == 'Email already exists. Please signin!') {
                            setShowLoginLink(true);
                        }
                        else {
                            setAccountErrorMessage(response.data.message);
                            setShowAccountError(true);
                        }
                        setCreateAccountText('Creating Account');
                    }
                });
            }
        }
    }

    const handleTermsAndConditions = () => {
        handleCloseButtonClick(closeSheet);
        history.push('/terms');
    }

    const handlePrivacyPolicy = () => {
        handleCloseButtonClick(closeSheet);
        history.push('/privacy-policy');
    }

    const handleSignUpPassword = () => {
        if(signUpPasswordElement.current.type === 'password') {
            signUpPasswordElement.current.type = 'text';
        }
        else {
            signUpPasswordElement.current.type = 'password';
        }
    };

    const handleGoogleSignIn = useGoogleLogin({
        onSuccess: codeResponse => socialLogin('google-oauth2', codeResponse.code),
        flow: 'auth-code',
        redirect_uri: window.location.origin
    });

    const handleFacebookSignIn = (response) => {
        socialLogin('facebook', response.accessToken);
    }

    const handleAppleSignIn = (response) => {
        var authCode = response.authorization.code
        var idToken = response.authorization.id_token
        var email = null
        var firstName = null
        var lastName = null
       
        // For the very first time user signin with Apple
        if (response.user){
            var email = response.user.email
            var firstName = response.user.name.firstName
            var lastName = response.user.name.lastName
        }

        var data = {
            'auth_code': authCode,
            'id_token': idToken,
            'email': email,
            'first_name': firstName,
            'last_name': lastName
          }
        appleSignin(data)
    };

    const handleForgotPassword = () => {
        window.dataLayer.push({'event': 'forgot_password_start'});
        setOpenForgotPassword(true);
    }

    const CloseForgotPassword = () => {
        setOpenForgotPassword(false);
    }
    const handleModalSignin = () => {
        window.dataLayer.push({'event': 'modal_sign_in_top'});
        setShowLogin(true);
    }
    const handleShowSignin = () => {
        window.dataLayer.push({'event': 'modal_sign_in_bottom'});
        setShowLogin(!showLogin);
    }
    const handleModalCreateAccount = () => {
        window.dataLayer.push({'event': 'modal_create_account_top'});
        setShowLogin(false);
    }
    const handleShowCreateAccount = () => {
        window.dataLayer.push({'event': 'modal_create_account_bottom'});
        setShowLogin(false);
    }
    const closeModal = () => {
        window.dataLayer.push({'event': 'account_sheet_close'});
        handleCloseButtonClick(closeSheet)
    }

    return(
        <>
        {
            (props) && (
            <BottomSheet open={props.isBottomSheetOpen} onDismiss={closeModal}
                header={
                    <div className="transparent-header">
                        <img className='cancel-icon' height='25px' src={cancelIcon} onClick={closeModal} />
                    </div>
                }
            >
                {
                    (showAccountLoader) && (
                        <span class="account-loader"></span>) 
                }
                {
                    (openForgotPassword) && (
                        <ForgotPassword CloseForgotPassword={CloseForgotPassword} />
                    )
                }
                {
                    (showAccount) ? (
                    <div className='account-container' id='signup-signin-container' ref={accountSheetElement}>            
                        <div className="top-bar">
                            <p className={showLogin ? 'tab-text highlight-tab' : 'tab-text'} id='login-button' onClick={handleModalSignin}>Sign In</p>
                            {
                                <p className={showLogin ? 'tab-text' : 'tab-text highlight-tab'} id='account-button' onClick={handleModalCreateAccount}>Create Account</p>
                            }
                        </div>
                        <hr></hr>
                        {
                            (showLogin) ? (
                            <div id='login-container'>
                                <div className='content-account'> 
                                {
                                    (showLoginEmail) ? (
                                    <div>
                                        <div className='account-inputs'>
                                            <p className='instruct-text'>Please sign in to your account to see the value of this business and millions more.</p>
                                            <div>
                                                <input 
                                                    className="mail-input" 
                                                    type="email"
                                                    id='login-email'
                                                    placeholder='Email address' 
                                                    value={emailAddress}
                                                    onChange={(e) => setEmailAddress(e.target.value)}
                                                    onKeyPress={(e) => ((e.key == 'Enter') && handleCheckPassword())}
                                                />
                                                {
                                                    (showLoginError) && (
                                                    <p className='error-message-login'>{errorMessage}</p>)
                                                }
                                            </div>
                                        </div>
                                        {
                                            (emailAddress.trim().length != 0) ? (
                                                <Submit actionText={nextText} callFunction={handleCheckPassword} disable={nextText != 'Next' && true} />
                                            ) : (
                                                <Submit actionText={'Next'} disable={'button'} />
                                            )
                                        }
                                    </div>) : (
                                        <div>
                                            <div className='account-inputs'>
                                            <p className='instruct-text'>{setPassword ? 'Enter a password to complete creating an account. Your password must be at least 8 or more characters with at least 1 lowercase, 1 uppercase, 1 number and 1 special character.' : 'Enter your password.'}</p>
                                            <div className='password-container'>
                                                <input 
                                                    className='password-input' 
                                                    type="password" 
                                                    id='login-password'
                                                    placeholder={setPassword ? 'Create password' : 'Enter password'}
                                                    ref={passwordElement}
                                                    value={loginPassword}
                                                    onChange={(e) => setLoginPassword(e.target.value)}
                                                    onKeyPress={(e) => ((e.key == 'Enter') && handleLogin())}
                                                />
                                                <img src={eyeicon} className='eye-icon-class' onClick={() => handlePassword()} />
                                                {
                                                    (showLoginError) && (
                                                    <p className='error-message-login'>{errorMessage}</p>)
                                                }
                                            </div>
                                        </div>
                                        {
                                            (loginPassword.trim().length != 0) ? (
                                                <Submit actionText={signInText} callFunction={handleLogin} disable={signInText != 'Sign In' && true} />
                                            ) : (
                                                <Submit actionText={'Sign In'} disable={'button'} />
                                            )
                                        }
                                        </div>
                                    )
                                    
                                }


                                    <h className='or-line'>
                                        <span>or</span>
                                    </h>
                                </div>
                                
                                <div className='content-button'>
                                    <div className='other-accounts'>
                                        <img className='social-button' height='45px' src={googleIcon} onClick={() => handleGoogleSignIn()} />
                                        <AppleLogin
                                            clientId={process.env.REACT_APPLE_CLIENT_ID}
                                            redirectURI={`${window.location.origin}/`}
                                            usePopup={true}
                                            callback={handleAppleSignIn}
                                            scope="email name"
                                            responseMode="query"
                                            render={renderProps => (  
                                                <img className='social-button' height='45px' src={appleIcon} onClick={renderProps.onClick}/>
                                            )}
                                        />
                                        {/* <FacebookLogin
                                            appId={process.env.REACT_FB_CLIENT_ID}
                                            autoLoad={false}
                                            fields="name,email,picture"
                                            callback={handleFacebookSignIn}
                                            render={renderProps => (
                                                <img className='social-button' height='45px' src={facebookIcon} onClick={renderProps.onClick}/>
                                            )}
                                        /> */}
                                    </div>
                                    <p className='forgot-password' onClick={handleForgotPassword}>Forgot Password?</p>
                                                
                                    <p className='signin-signup-buttons'>
                                        <span className='user-text'>New to RS11? </span>
                                        <span className='process-text' onClick={handleShowCreateAccount}>Create Account</span>
                                    </p>
                                    
                                    <p className='agree-text'>
                                        <span className='condition-text'>By using our services, you agree to abide by our </span>
                                        <span className='condition-text highlight-text' onClick={() => handleTermsAndConditions()}>Terms & Condition </span>
                                        <span className='condition-text'>and </span>
                                        <span className='condition-text highlight-text' onClick={() => handlePrivacyPolicy()}>Privacy policy</span>
                                    </p>
                                </div>
                            </div>) : (
                            <div id='create-account-container'>                  
                                <div className='content-account'>                     
                                    <div className='account-inputs'>
                                        <p className='instruct-text'>Enter your email address to see the estimated valuation for millions more businesses.</p>
                                           <input 
                                               className={'mail-input'}
                                               type="email"
                                               id='enter-email'
                                               placeholder='Email address' 
                                               value={signUpEmail}
                                               onKeyPress={(e) => ((e.key == 'Enter') && handleEnterEmail())}
                                               onChange={(e) => setSignUpEmail(e.target.value)}
                                           />
                                            {
                                                (showAccountError) && (
                                                <p className='error-message'>{accountErrorMessage}</p>)
                                            } 
                                            {
                                                (showLoginLink) && (
                                                <p className='error-message'>Email already exists. Please sign in. <span onClick={() => setShowLogin(true)}>Sign in</span></p>)
                                            }  
                                    </div>  
                                       {          
                                           (signUpEmail.trim().length != 0) ? ( 
                                               <Submit actionText={createAccountText} callFunction={handleEnterEmail} disable={createAccountText != 'Create Account' && true} />
                                           ) : (
                                               <Submit actionText={'Create Account'} disable={'button'} />
                                           )
                                       }
                                       <h className='or-line'>
                                           <span>or</span>
                                       </h>
                                </div> 
                                <div className='content-button'>
                                    <div className='other-accounts'>
                                        <img className='social-button' height='45px' src={googleIcon} onClick={() => handleGoogleSignIn()} />
                                        <AppleLogin
                                            clientId={process.env.REACT_APPLE_CLIENT_ID}
                                            redirectURI={`${window.location.origin}/`}
                                            usePopup={true}
                                            callback={handleAppleSignIn}
                                            scope="email name"
                                            responseMode="query"
                                            render={renderProps => (  
                                                <img className='social-button' height='45px' src={appleIcon} onClick={renderProps.onClick}/>
                                            )}
                                        />
                                        {/* <FacebookLogin
                                            appId={process.env.REACT_FB_CLIENT_ID}
                                            autoLoad={false}
                                            fields="name,email,picture"
                                            callback={handleFacebookSignIn}
                                            render={renderProps => (
                                                <img className='social-button' height='45px' src={facebookIcon} onClick={renderProps.onClick}/>
                                            )}
                                        /> */}
                                    </div>
                                    <p className='signin-signup-buttons'>
                                        <span className='user-text'>Already member? </span>
                                        <span className='process-text' onClick={handleShowSignin}>Sign In</span>
                                    </p>
                                    <p className='agree-text'>
                                        <span className='condition-text'>By using our services, you agree to abide by our </span>
                                        <span className='condition-text highlight-text' onClick={() => handleTermsAndConditions()}>Terms & Condition </span>
                                        <span className='condition-text'>and </span>
                                        <span className='condition-text highlight-text' onClick={() => handlePrivacyPolicy()}>Privacy policy</span>
                                    </p>
                                </div>
                            </div>)
                        }
                    </div>) : (
                    <div className='inbox-container' id='inbox-container'>
                        <img className='inbox-image' src={inbox} alt='inbox-image' height='51px' />
                        <p className='verify-text'>Please verify your email</p>
                        <p className='receive-text'>You will receive a temporary link from us at {signUpEmail != '' ? signUpEmail : Cookies.get('signup_id')}.</p>
                        <p className='check-text'>If this email isn't in your inbox, please check your Spam folder.</p>
                        <div className='resend-mail'>
                            <span className='get-mail'>Didn't get it? </span>
                            <span className='resend' onClick={() => handleCreateAccountOrResend('resend')}>Resend Email</span>
                        </div>
                        {
                            (resendText) && (
                                <p className='resend-text'>{resendTextMessage}</p>
                            )
                        }
                    </div>
                    )
                }
            </BottomSheet>)
        }
        </> 
    )
}

export default LoginBottomSheet;


